export enum IndicesCorrecaoEnum {
  IGPM = 'IGP-M',
  IGPDI = 'IGP-DI',
  IPCA = 'IPCA',
  INCC = 'INCC',
  OutroIndice = 'Outro',
  SemCorrecao = 'Sem correção',
  CDI = 'CDI'
}
